import { CheckboxOption } from 'shared/common/ConvertToCheckboxOptions'

import { useEffect, useState } from 'react'

import { useGetUserRolesQuery } from 'modules/AccessManage/services/accessManageApi'

export const useUsers = () => {
  const { data: roles, isFetching: isRolesFetching } = useGetUserRolesQuery()

  const [roleOptions, setRoleOptions] = useState<CheckboxOption[]>([])

  useEffect(() => {
    if (roles?.success) {
      setRoleOptions(
        roles.result.map((role) => ({
          label: role.name,
          value: `${role.id}`,
        })),
      )
    }
  }, [roles])

  return {
    roleOptions,
    isRolesFetching,
  }
}
